import { useEffect } from "react";
import LandingNavigation from "@/components/landing/LandingNavigation";
import LandingHero from "@/components/landing/LandingHero";
import SocialProofBar from "@/components/landing/SocialProofBar";
import ProblemSection from "@/components/landing/ProblemSection";
import ConsolidationSection from "@/components/landing/ConsolidationSection";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import StatsSection from "@/components/landing/StatsSection";
import CtaSection from "@/components/landing/CtaSection";
import LandingFooter from "@/components/landing/LandingFooter";
import BookingModal, { useBookingModal } from "@/components/landing/BookingModal";

export default function Index() {
  const { open, openBooking, closeBooking } = useBookingModal();

  useEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains('dark');
    const prevTheme = root.getAttribute('data-theme');
    root.removeAttribute('data-theme');
    root.classList.add('dark');
    return () => {
      if (!hadDark) root.classList.remove('dark');
      if (prevTheme) root.setAttribute('data-theme', prevTheme);
    };
  }, []);

  return (
    <div className="min-h-screen dark bg-background text-foreground">
      <LandingNavigation onScheduleDemo={openBooking} />
      <main>
        <LandingHero onScheduleDemo={openBooking} />
        {/* <SocialProofBar /> */}
        <ProblemSection />
        <ConsolidationSection />
        <FeaturesGrid />
        <StatsSection />
        <CtaSection onScheduleDemo={openBooking} />
      </main>
      <LandingFooter />
      <BookingModal open={open} onClose={closeBooking} />
    </div>
  );
}
